export const c_notification_drawer__group_toggle_title_max_lines = {
  "name": "--pf-v6-c-notification-drawer__group-toggle-title--max-lines",
  "value": "1",
  "var": "var(--pf-v6-c-notification-drawer__group-toggle-title--max-lines)"
};
export default c_notification_drawer__group_toggle_title_max_lines;